import { render } from "./SelectCoverTypeTabs.vue?vue&type=template&id=3be1070c"
import script from "./SelectCoverTypeTabs.vue?vue&type=script&lang=js"
export * from "./SelectCoverTypeTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__